import React, { useState } from "react";

const DISCORD_WEBHOOK_URL =
  "https://discord.com/api/webhooks/1375119383931654217/2EpZVq5hR5QvwtWSu3FtUooLVjTNv9qhigOcO4fEek1uGDznt7PBt2b0T26SkUPyPZ-D";

const EventFeedback = () => {
  const [form, setForm] = useState({
    eventName: "",
    eventDate: "",
    rating: "",
    feedback: "",
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const validate = () => {
    const newErrors = {};
    if (!form.eventName.trim()) newErrors.eventName = "Event name is required";
    if (!form.eventDate) newErrors.eventDate = "Event date is required";
    if (!form.rating) newErrors.rating = "Please provide a rating";
    if (!form.feedback.trim()) newErrors.feedback = "Feedback cannot be empty";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const embed = {
      title: "📝 New Event Feedback",
      color: 0x1abc9c,
      fields: [
        { name: "Event Name", value: form.eventName },
        { name: "Event Date", value: form.eventDate },
        { name: "Rating", value: `${form.rating} ${form.rating === "1" ? "star" : "stars"}` },
        { name: "Feedback", value: form.feedback },
      ],
      timestamp: new Date().toISOString(),
    };

    try {
      const response = await fetch(DISCORD_WEBHOOK_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ embeds: [embed] }),
      });

      if (response.ok) {
        setSubmitted(true);
        setForm({ eventName: "", eventDate: "", rating: "", feedback: "" });
        setErrors({});
        setErrorMsg("");
      } else {
        setErrorMsg("❌ Submission failed. Please try again.");
      }
    } catch (error) {
      setErrorMsg("❌ Network error. Please try again later.");
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Event Feedback</h2>
      {submitted && <p style={styles.success}>✅ Thank you for your feedback!</p>}
      {errorMsg && <p style={{ ...styles.error, textAlign: "center" }}>{errorMsg}</p>}
      <form onSubmit={handleSubmit} noValidate style={styles.form}>
        <label style={styles.label}>
          Event Name:
          <input
            type="text"
            name="eventName"
            value={form.eventName}
            onChange={handleChange}
            style={styles.input}
            placeholder="Enter the event name"
          />
          {errors.eventName && <p style={styles.error}>{errors.eventName}</p>}
        </label>

        <label style={styles.label}>
          Event Date:
          <input
            type="date"
            name="eventDate"
            value={form.eventDate}
            onChange={handleChange}
            style={styles.input}
          />
          {errors.eventDate && <p style={styles.error}>{errors.eventDate}</p>}
        </label>

        <label style={styles.label}>
          Rating:
          <select
            name="rating"
            value={form.rating}
            onChange={handleChange}
            style={styles.select}
          >
            <option value="">-- Select a rating --</option>
            {[1, 2, 3, 4, 5].map((r) => (
              <option key={r} value={r}>
                {r} {r === 1 ? "star" : "stars"}
              </option>
            ))}
          </select>
          {errors.rating && <p style={styles.error}>{errors.rating}</p>}
        </label>

        <label style={styles.label}>
          Feedback:
          <textarea
            name="feedback"
            value={form.feedback}
            onChange={handleChange}
            style={styles.textarea}
            placeholder="Share your thoughts about the event"
            rows={5}
          />
          {errors.feedback && <p style={styles.error}>{errors.feedback}</p>}
        </label>

        <button type="submit" style={styles.button}>
          Submit Feedback
        </button>
      </form>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "600px",
    margin: "2rem auto",
    padding: "1.5rem",
    backgroundColor: "rgba(20, 20, 40, 0.85)",
    borderRadius: "12px",
    color: "#f0f0f0",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.7)",
  },
  title: {
    textAlign: "center",
    fontSize: "2rem",
    marginBottom: "1rem",
    background: "linear-gradient(90deg, #00d8d6, #1982c4)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "900",
  },
  success: {
    textAlign: "center",
    marginBottom: "1rem",
    color: "#4CAF50",
    fontWeight: "bold",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  label: {
    display: "flex",
    flexDirection: "column",
    fontSize: "1rem",
    fontWeight: "600",
  },
  input: {
    marginTop: "0.3rem",
    padding: "0.5rem 0.75rem",
    borderRadius: "6px",
    border: "1px solid #555",
    backgroundColor: "#222",
    color: "#eee",
    fontSize: "1rem",
  },
  select: {
    marginTop: "0.3rem",
    padding: "0.5rem 0.75rem",
    borderRadius: "6px",
    border: "1px solid #555",
    backgroundColor: "#222",
    color: "#eee",
    fontSize: "1rem",
  },
  textarea: {
    marginTop: "0.3rem",
    padding: "0.5rem 0.75rem",
    borderRadius: "6px",
    border: "1px solid #555",
    backgroundColor: "#222",
    color: "#eee",
    fontSize: "1rem",
    resize: "vertical",
  },
  error: {
    color: "#ff6b6b",
    marginTop: "0.25rem",
    fontSize: "0.85rem",
    fontWeight: "600",
  },
  button: {
    marginTop: "1rem",
    padding: "0.75rem",
    borderRadius: "8px",
    border: "none",
    background: "linear-gradient(90deg, #00d8d6, #1982c4)",
    color: "#fff",
    fontSize: "1.1rem",
    fontWeight: "700",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
};

export default EventFeedback;
